import React, { useState, useEffect, useRef } from "react";
import Select from "../../ui/PortalSelect";
import "antd/dist/antd.css";
import Swal from 'sweetalert2';
import axios from 'axios';
import { baseURL } from '../backend_url';
import { loadAccessibleCompanies, readSessionUser } from '../accountAccess';
import { messageFromError, readJsonResponse } from '../saveResponse';


export default function UpdateForm() {

  var obj_company_detail = "";

  const [companyDetail, setcompanyDetail] = useState([]);
  const [companyName, setCompanyName] = useState("");
  const [company_id, setcompany_id] = useState("");
  const [loggedInUserDetail, setLoggedInUserDetail] = useState({});
  const [rateCodeLocationMap, setRateCodeLocationMap] = useState([]);
  const [rateIDHash, setRateIDHash] = useState({});
  const [rateCodeDetail, setRateCodeDetail] = useState([]);
  const [rateCode, setRateCode] = useState('');
  const [currencyGrid, setCurrencyGrid] = useState([["", "", ""]]);
  const [dynamicGrid, setDynamicGrid] = useState([[""]]);
  const [fromCur, setFromCur] = useState([{}]);
  const [toCur, setToCur] = useState([{}]);
  const [changeValue, setChangeValue] = useState([{}]);
  const [availableFromCur, setAvailableFromCur] = useState([{}]);
  const [numDropdowns, setNumDropdowns] = useState(1);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    const { user, error } = readSessionUser();

    if (error) {
      setLoggedInUserDetail({});
      setcompanyDetail([]);
      return;
    }

    setLoggedInUserDetail(user);
    loadAccessibleCompanies(baseURL, user, 'CurrencyConverter_Account Access')
      .then(setcompanyDetail)
      .catch(() => setcompanyDetail([]));
  }, []);

  useEffect(() => {
    if (companyDetail && companyName) {
        let obj_company_detail = companyDetail.filter(
            (value) => value.company_name === companyName
        )[0];
        let temp_company_id = obj_company_detail._id;
        setcompany_id(temp_company_id)
        setNumDropdowns(1);
        setCurrencyGrid([["", "", ""]]);
        setDynamicGrid([[""]]);
        axios
        .get(
          baseURL + "/get_currency_conversion/" + temp_company_id
          + "?companyNumber=" + encodeURIComponent(temp_company_id.toString())
        )
        .then((res) => {
          const selectedItems = Array.isArray(res.data?.selected_items)
            ? res.data.selected_items
            : [];
          if (selectedItems.length > 0) {
            setNumDropdowns(selectedItems.length);
            setCurrencyGrid(selectedItems);
          }
        });

    }
  }, [companyName]);

  const fromCurrencyOption = [
    { id: 1, value: "USD", label: "USD" },
    // { id: 2, value: "CAD", label: "CAD" },
    // { id: 2, value: "EURO", label: "EURO" },
  ];

  const toCurrencyOption = [
    { id: 1, value: "USD", label: "USD" },
    { id: 2, value: "CAD", label: "CAD" },
    { id: 3, value: "EUR", label: "EUR" },
    { id: 4, value: "AED", label: "AED" }
  ];

  const handleInputChangeFromCur = (characterEntered, i) => {
      let arr1 = [...currencyGrid];
      arr1[i][0] = characterEntered;

      const usedCurrency = arr1
      .filter((row, index) => index !== i && row[0].value)
      .map(row => row[0].value);
      if (characterEntered) {

        usedCurrency.push(characterEntered.value);
      }
      const newAvailableCurrency = fromCurrencyOption.filter(
        option => !usedCurrency.includes(option.value)
      );
      if (!characterEntered) {
        newAvailableCurrency.push({ value: arr1[i][0].value, label: arr1[i][0].value });
      }
      setCurrencyGrid(arr1); 
      setAvailableFromCur(newAvailableCurrency);
  };

  const handleInputChangeToCur = (characterEntered, i) => {
    let arr1 = [...currencyGrid];
    arr1[i][1] = characterEntered;
    setCurrencyGrid(arr1);
  };

  const handleButtonClick = (i) => {
    const fromCurrency = currencyGrid[i][0]['label']
    const toCurrency = currencyGrid[i][1]['label']
    if (fromCurrency == undefined || fromCurrency == ""){
      Swal.fire("Please Select From Curreny")
      return;
    }

    if (toCurrency == undefined || toCurrency == ""){
      Swal.fire("Please Select To Curreny")
      return;
    }
    

    const body_payload = {
      companyNumber: company_id.toString(),
      fromCurrency: fromCurrency,
      toCurrency: toCurrency,
    };
    axios.post(baseURL + "/get_automation_currency_conversion", body_payload).then((res) => {
      let arr1 = [...dynamicGrid];
      arr1[i] = res.data;
      setDynamicGrid(arr1);

      //axios.post(baseURL + "/save_xml_response_info", body_payload).then((res) => {
      // Swal.fire({
      //   position: "center",
      //   icon: "success",
      //   title: "Currency Conversion Saved Successfully",
      //   showConfirmButton: false,
      //   timer: 3000,
      // });
    }); 
    // let arr1 = [...currencyGrid];
    // arr1[i][1] = characterEntered;
    // setCurrencyGrid(arr1);
  };

  const handleInputChangeValue = (characterEntered, i) => {
    let arr1 = [...currencyGrid];
    arr1[i][2] = characterEntered;
    setCurrencyGrid(arr1);
  };

  const handleAddDropdown = () => {
    setNumDropdowns(numDropdowns + 1);
    let arr1 = [...currencyGrid];
    arr1.push(["", "", ""]);
    setCurrencyGrid(arr1);
  };

  const handleClear = () => {
    setNumDropdowns(1);
    setCurrencyGrid([["", "", ""]]);
    setDynamicGrid([[""]]);
  };
  const handleInputChangeCompanyName = characterEntered => {
    setCompanyName(characterEntered.value);
  };

  const companyNameOptions = companyDetail.map((value) => (
    { value: value.company_name, label: value.company_name }
  ));

  const handleSubmit = async () => {

    if (companyName === "") {
      Swal.fire('Please select Account Name');
      return;
    }

    if (!company_id) {
      Swal.fire('The selected Account could not be identified. Please reselect it and try again.');
      return;
    }

    let isValid = true;
    const firstRowFromCur = currencyGrid[0][0]['label'];
    const firstRowToCur = currencyGrid[0][1]['label'];
    const firstRowChangeValue = currencyGrid[0][2];
    const columnLabels = ["From Currency", "To Currency", "Conversion Value"];
    if (firstRowFromCur === '' || firstRowFromCur === undefined) {
      Swal.fire(`Please Select a From Currency for the first row`);
      return;
    }

    if (firstRowToCur === '' || firstRowToCur === undefined) {
      Swal.fire(`Please Select a To Currency for the first row`);
      return;
    }


    if (firstRowChangeValue === '' || firstRowChangeValue === undefined) {
      Swal.fire(`Please enter the Conversion Value for the first row`);
      return;
    }

    if (isValid) {
      for (let rowIndex = 0; rowIndex < currencyGrid.length; rowIndex++) {
        const row = currencyGrid[rowIndex];
        if (row[0]["value"]) {
          for (let colIndex = 1; colIndex < row.length; colIndex++) {
            const cellValue = row[colIndex];
            if (!cellValue || (cellValue.value && cellValue.value.toString().trim() === '')) {
              isValid = false;
              Swal.fire(`In Row ${rowIndex + 1}, for ${columnLabels[0]} as "${row[0]["value"]}" the ${columnLabels[colIndex]} has an empty slection. Please select it.`);
              return; 
            }
          }
        }
      }
    }

    const filteredArray = currencyGrid.filter(innerArray => {
      const firstValue = innerArray[0];
      return firstValue !== undefined && firstValue !== '';
    });

    const body_payload = {
      companyNumber: company_id.toString(),
      // location_name: locationName,
      // location_id: locationId.toString(),
      company_id: company_id,
      selected_items: filteredArray,
      created_by: loggedInUserDetail.userEmail,
      updated_by: loggedInUserDetail.userEmail,
      created_date: new Date(),
      updated_date: new Date()
    };

    setSaving(true);
    fetch(baseURL + "/save_currency_conversion", {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body_payload),
    })
      .then((response) => readJsonResponse(response, 'Currency Conversion save'))
      .then((data) => {
        if (data !== 'success') {
          throw new Error('The server did not confirm that Currency Conversion was saved. Your form has been kept.');
        }

        Swal.fire({
          position: "center",
          icon: "success",
          title: "Currency Conversion saved successfully",
          showConfirmButton: false,
          timer: 3000,
        });
      })
      .catch((error) => {
        console.error('Unable to save Currency Conversion:', error)
        Swal.fire({
          icon: 'error',
          title: 'Currency Conversion was not saved',
          text: messageFromError(error, 'Unable to save Currency Conversion. Please try again.'),
        })
      })
      .finally(() => setSaving(false));
  };



  return (
    <>
                  <div className="row pt-3 justify-content-center align-items-center">
                            <div className="col-12 col-sm-4 col-lg-2 mb-2 mb-sm-3">
                                <label htmlFor="company_name" className="form-label" style={{ marginTop: 5 }}>
                                  <b>Account Name</b> 
                                </label>
                            </div>

                            <div className="col-12 col-sm-8 col-lg-4 mb-3">
                                <Select
                                    value={{ value: companyName, label: (companyName ? companyName : "Select Account Name") }}
                                    inputId="company_name"
                                    name="company_name"
                                    options={companyNameOptions}
                                    onChange={handleInputChangeCompanyName}
                                />
                            </div>
                  </div>
          <div className="col-12 px-3">
                  <div className=" mt-3"
                    style={{ border: "5px solid black", padding: "20px", margin: "20px 0" }}
                  >
                    <div className="row justify-content-center g-3 d-none d-xl-flex">
                      <div className="col-12 col-sm-6 col-xl-3">
                        <div className="rms-heading center-text">From Currency</div>
                      </div>
                      <div className="col-12 col-sm-6 col-xl-3">
                        <div className="rms-heading center-text">To Currency</div>
                      </div>
                      <div className="col-12 col-sm-6 col-xl-3">
                        <div className="rms-heading center-text">Get Dynamic Conversion </div>
                      </div>
                      <div className="col-12 col-sm-6 col-xl-3">
                        <div className="rms-heading center-text">Conversion Value</div>
                      </div>
                    </div>
                    {[...Array(numDropdowns)].map((_, i) => (
                      <div
                        className="row justify-content-center align-items-center g-3 mt-2"
                      >
                          <div className="col-12 col-sm-6 col-xl-3 text-center">
                            <div className="rms-heading d-xl-none mb-2">From Currency</div>
                            <Select
                              value={{
                                value: currencyGrid[i][0]["value"],
                                label: currencyGrid[i][0]["value"]
                                  ? currencyGrid[i][0]["value"]
                                  : "Select From Currency",
                              }}
                              options={fromCurrencyOption}
                              onChange={(e) => handleInputChangeFromCur(e, i)}
                            />
                          </div>
                          <div className="col-12 col-sm-6 col-xl-3 text-center">
                            <div className="rms-heading d-xl-none mb-2">To Currency</div>
                            <Select
                              value={{
                                value: currencyGrid[i][1]["value"],
                                label: currencyGrid[i][1]["value"]
                                  ? currencyGrid[i][1]["value"]
                                  : "Select To Currency",
                              }}
                              options={toCurrencyOption}
                              onChange={(e) => handleInputChangeToCur(e, i)}
                            />
                          </div>
                          <div className="col-12 col-sm-6 col-xl-3">
                            <div className="rms-heading d-xl-none mb-2">Get Dynamic Conversion</div>
                            <div className="d-flex flex-wrap align-items-center gap-2">
                              <div className="flex-grow-1">
                                <button onClick={() => handleButtonClick(i)}>Get Values</button>
                              </div>
                              <div className="flex-grow-1" style={{ minWidth: 0 }}>
                                <input type="number"
                                 value={dynamicGrid[i]}
                                 style={{width: "100%"}}
                                 disabled={true} />
                              </div>
                            </div>
                          </div>
                          {/* <div className="col-md-2">
                            <button onClick={() => handleButtonClick(i)}>Get Values</button>
                            <input
                              type="number"
                              value={dynamicGrid[i]}
                              />

                          </div> */}
                          <div className="col-12 col-sm-6 col-xl-3">
                            <div className="rms-heading d-xl-none mb-2">Conversion Value</div>
                            <input
                              type="number"
                              className="form-control"
                              value={currencyGrid[i][2]}
                              onChange={(e) =>
                                handleInputChangeValue(e.target.value, i)
                              }
                            />
                          </div>
                      </div>
                    ))}

                    <div className="d-flex flex-wrap gap-2 mt-4">
                      <button
                        type="submit"
                        className="btn btn-success"
                        onClick={handleAddDropdown}
                        style={{ backgroundColor: "green" }}
                      >
                        Add
                      </button>
                      <button
                        className="btn btn-primary"
                        type="button"
                        onClick={handleSubmit}
                        disabled={saving}
                      >
                        {saving ? (
                          <>
                            <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true" />
                            Saving...
                          </>
                        ) : 'Submit'}
                      </button>
                      <button
                        className="btn btn-danger"
                        type="cancel"
                        style={{}}
                        onClick={handleClear}
                      >
                        Clear
                      </button>
                    </div>
                  </div>
            </div>
    </>
  );
}
